/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActivitySettings interface.
 */
export function instanceOfActivitySettings(value) {
    let isInstance = true;
    isInstance = isInstance && "isLiked" in value;
    isInstance = isInstance && "isDenylisted" in value;
    return isInstance;
}
export function ActivitySettingsFromJSON(json) {
    return ActivitySettingsFromJSONTyped(json, false);
}
export function ActivitySettingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        isLiked: json.isLiked,
        isDenylisted: json.isDenylisted,
    };
}
export function ActivitySettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        isLiked: value.isLiked,
        isDenylisted: value.isDenylisted,
    };
}
